import { render } from "./Pause.vue?vue&type=template&id=4f67c802&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"

import "./Pause.vue?vue&type=style&index=0&id=4f67c802&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f67c802"]])

export default __exports__